import cookies from 'js-cookie';
import useBaseAPI from './useBaseAPI';
import { removeAuthToken } from '../../helper/authHelper';

const useAuthAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const login = async (payload) =>
    client('post', '/auth/login', payload, { authRedirect: false }).then(
      (data) => {
        if (data.redirectURL) {
          window.location.href = data.redirectURL;
        }
        return data;
      },
      (error) =>
        new Promise((resolve, reject) => {
          reject(error);
        }),
    );

  const loginByOTP = async (userName, code) =>
    client('post', '/auth/login/otp', { userName, code }).then(
      (data) => {
        if (data.success) {
          if (data.data) {

            Object.keys(data.data).forEach((cookie) => {
              if (cookie === 'authToken') {
                localStorage.setItem(cookie, data.data[cookie]);
              } else {
                cookies.set(cookie, data.data[cookie]);
              }
            });
          }

          window.location.href = '/';
        }
        return true;
      },
      (error) =>
        new Promise((resolve, reject) => {
          reject(error);
        }),
    );

  const logout = async () =>
    client('post', '/auth/logout').then(
      (data) => {
        removeAuthToken()
        if (data.redirectURL)
          window.location.href = data.redirectURL;
        else
          window.location.href = '/login';
      },
      (error) =>
        new Promise((resolve, reject) => {
          reject(error);
        }),
    );

  const getUserProfile = async () => {
    try {
      const response = await client('get', '/user/profile');
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const updateUserProfile = async (payload) => {
    try {
      const response = await client('post', '/user/update-profile', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    login,
    loginByOTP,
    logout,
    getUserProfile,
    updateUserProfile,
    isLoading,
  };
};

export default useAuthAPI;
